<template>
  <div class="wrapp-card">
    <template v-if="accordion.useComponent">
      <component :is="accordion.useComponent" :attribute="accordion" :product="product" :variantSelected="variantSelected"></component>
    </template>
    <template v-else>
      <b-card no-body>
        <b-card-header header-tag="header" role="tab">
          <button v-b-toggle="'accordion-' + accordion.key" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
            <div class="title">{{accordion.label}}</div>
            <svg class="o-icon"><use xlink:href="#plus-circle"></use></svg>
          </button>
        </b-card-header>
        <b-collapse :id="`accordion-${accordion.key}`" accordion="info-product" role="tabpanel">
          <b-card-body>
            <div v-if="accordion.value" class="attribute-wrapper">
              <div v-html="accordion.value"></div>
            </div>
            <template v-for="(contain, indexContain) in accordion.contains">
              <div class="attribute-wrapper" :key="indexContain" :class="`attr-${contain.key}`">
                <component v-if="contain.useComponent" :is="contain.useComponent" :attribute="contain" :product="product" :variantSelected="variantSelected"></component>
                <div v-else class="attribute-row">
                  <span class="label" v-show="contain.label">{{contain.label}}</span>
                  <div v-html="contain.value" />
                </div>
              </div>
            </template>
          </b-card-body>
        </b-collapse>
      </b-card>
    </template>
  </div>
</template>

<script>
import AccordionProductCode from 'theme/components/Accordion/layouts/AccordionProductCode'
import AccordionTecnicalData from 'theme/components/Accordion/layouts/AccordionTecnicalData'
import AccordionCareComposition from 'theme/components/Accordion/layouts/AccordionCareComposition'
import AccordionSustainability from 'theme/components/Accordion/layouts/AccordionSustainability'
import AccordionProductAvailability from 'theme/components/Accordion/layouts/AccordionProductAvailability'

export default {
  name: 'AccordionManager',
  props: {
    accordion: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    variantSelected: {
      type: Array | Object,
      required: false
    }
  },
  components: {
    AccordionProductAvailability,
    AccordionProductCode,
    AccordionTecnicalData,
    AccordionCareComposition,
    AccordionSustainability
  }
}
</script>
